import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-reset-password-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './reset-password.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ResetPasswordTemplateData>;
}

export type ResetPasswordTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  p2_html: string;
  p3: string;
  footer: string;
  support_email: string;
};

export const ResetPasswordTemplateMocks: ResetPasswordTemplateData[] = [
  {
    title: 'Hello Olivia 👋',
    p1: "We've received a request to change your password. You can change your password through the link below.",
    button_link: 'http://recruitee.com',
    button_text: 'Change your password now',
    p2_html:
      'Or, simply click this link: </br><a href="http://recruitee.com">http://recruitee.com</a>',
    p3: "If you didn't request a new password, please ignore this email. Your password won't change until you access the link above and create a new password.",
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
